import { gql } from '@apollo/client';
import { useAxiosQuery, useLazyAxios } from '@isyc-react/oc-api';
import { useBuVariables } from 'common/utils/bu-variables-hook';
export const BAILLEURS_CONFIGURATION = gql `
  query bailleursConfiguration($businessUnitId: Long, $businessUnitCode: String) {
    bailleursConfiguration(businessUnitId: $businessUnitId, businessUnitCode: $businessUnitCode) {
      dateLimit
      helpUrl
      confidentialUrl
      legalMentionsUrl
      cristalFile
    }
  }
`;
export const useBailleursConfigurationLazyQuery = (options) => {
    var _a, _b;
    const buVariables = useBuVariables();
    return useLazyAxios({
        url: `/api/public/bailleurs/configuration?businessUnitId=${(_a = buVariables.businessUnitId) !== null && _a !== void 0 ? _a : ''}&businessUnitCode=${(_b = buVariables.businessUnitCode) !== null && _b !== void 0 ? _b : ''}`,
        method: 'GET'
    });
};
export const useBailleursConfigurationQuery = (options) => {
    var _a, _b;
    const buVariables = useBuVariables();
    return useAxiosQuery(`/api/public/bailleurs/configuration?businessUnitId=${(_a = buVariables.businessUnitId) !== null && _a !== void 0 ? _a : ''}&businessUnitCode=${(_b = buVariables.businessUnitCode) !== null && _b !== void 0 ? _b : ''}`);
};
